import React from 'react';
import Layout from '@/components/Layout';
import MicroGiftInventory from '@/components/MicroGiftInventory';
import { useNavigate, Link } from 'react-router-dom';
import { type Gift, type Brand, type GiftAmount } from '@/utils/types';
import { Home, Activity, Info } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { 
  HoverCard, 
  HoverCardTrigger, 
  HoverCardContent 
} from '@/components/ui/hover-card';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

const MOCK_GIFTS: Gift[] = [
  // Starbucks gifts (beverages) - 6 transactions
  {
    id: 'gift-starbucks-1',
    brandId: 'starbucks',
    amount: 5 as GiftAmount,
    senderId: 'sender-1',
    recipientId: 'current-user',
    createdAt: new Date(2025, 3, 5),
    isRedeemed: false
  },
  {
    id: 'gift-starbucks-2',
    brandId: 'starbucks',
    amount: 5 as GiftAmount,
    senderId: 'sender-3',
    recipientId: 'current-user',
    createdAt: new Date(2025, 3, 4),
    isRedeemed: false
  },
  {
    id: 'gift-starbucks-3',
    brandId: 'starbucks',
    amount: 10 as GiftAmount,
    senderId: 'sender-5',
    recipientId: 'current-user',
    createdAt: new Date(2025, 3, 1),
    isRedeemed: false
  },
  {
    id: 'gift-starbucks-4',
    brandId: 'starbucks',
    amount: 10 as GiftAmount,
    senderId: 'sender-2',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 28),
    isRedeemed: false
  },
  {
    id: 'gift-starbucks-5',
    brandId: 'starbucks',
    amount: 15 as GiftAmount,
    senderId: 'sender-4',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 25),
    isRedeemed: false
  },
  {
    id: 'gift-starbucks-6',
    brandId: 'starbucks',
    amount: 25 as GiftAmount,
    senderId: 'sender-6',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 20),
    isRedeemed: false
  },
  
  // Dunkin gifts (beverages) - 5 transactions
  {
    id: 'gift-dunkin-1',
    brandId: 'dunkin',
    amount: 5 as GiftAmount,
    senderId: 'sender-4',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 27),
    isRedeemed: false
  },
  {
    id: 'gift-dunkin-2',
    brandId: 'dunkin',
    amount: 5 as GiftAmount,
    senderId: 'sender-2',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 24),
    isRedeemed: false
  },
  {
    id: 'gift-dunkin-3',
    brandId: 'dunkin',
    amount: 10 as GiftAmount,
    senderId: 'sender-3',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 22),
    isRedeemed: false
  },
  {
    id: 'gift-dunkin-4',
    brandId: 'dunkin',
    amount: 15 as GiftAmount,
    senderId: 'sender-1',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 20),
    isRedeemed: false
  },
  {
    id: 'gift-dunkin-5',
    brandId: 'dunkin',
    amount: 25 as GiftAmount,
    senderId: 'sender-5',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 18),
    isRedeemed: false
  },
  
  // Tim Hortons gifts (beverages) - 4 transactions
  {
    id: 'gift-timhortons-1',
    brandId: 'timhortons',
    amount: 5 as GiftAmount,
    senderId: 'sender-3',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 19),
    isRedeemed: false
  },
  {
    id: 'gift-timhortons-2',
    brandId: 'timhortons',
    amount: 10 as GiftAmount,
    senderId: 'sender-4',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 17),
    isRedeemed: false
  },
  {
    id: 'gift-timhortons-3',
    brandId: 'timhortons',
    amount: 10 as GiftAmount,
    senderId: 'sender-1',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 15),
    isRedeemed: false
  },
  {
    id: 'gift-timhortons-4',
    brandId: 'timhortons',
    amount: 15 as GiftAmount,
    senderId: 'sender-2',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 14),
    isRedeemed: false
  },
  
  // Krispy Kreme gifts (beverages) - 4 transactions
  {
    id: 'gift-krispy-1',
    brandId: 'krispy',
    amount: 5 as GiftAmount,
    senderId: 'sender-5',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 16),
    isRedeemed: false
  },
  {
    id: 'gift-krispy-2',
    brandId: 'krispy',
    amount: 5 as GiftAmount,
    senderId: 'sender-2',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 14),
    isRedeemed: false
  },
  {
    id: 'gift-krispy-3',
    brandId: 'krispy',
    amount: 10 as GiftAmount,
    senderId: 'sender-1',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 13),
    isRedeemed: false
  },
  {
    id: 'gift-krispy-4',
    brandId: 'krispy',
    amount: 15 as GiftAmount,
    senderId: 'sender-3',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 12),
    isRedeemed: false
  },
  
  // McDonald's gifts (restaurants) - 6 transactions
  {
    id: 'gift-mcdonalds-1',
    brandId: 'mcdonalds',
    amount: 5 as GiftAmount,
    senderId: 'sender-2',
    recipientId: 'current-user',
    createdAt: new Date(2025, 3, 3),
    isRedeemed: false
  },
  {
    id: 'gift-mcdonalds-2',
    brandId: 'mcdonalds',
    amount: 5 as GiftAmount,
    senderId: 'sender-4',
    recipientId: 'current-user',
    createdAt: new Date(2025, 3, 2),
    isRedeemed: false
  },
  {
    id: 'gift-mcdonalds-3',
    brandId: 'mcdonalds',
    amount: 10 as GiftAmount,
    senderId: 'sender-1',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 30),
    isRedeemed: false
  },
  {
    id: 'gift-mcdonalds-4',
    brandId: 'mcdonalds',
    amount: 10 as GiftAmount,
    senderId: 'sender-5',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 28),
    isRedeemed: false
  },
  {
    id: 'gift-mcdonalds-5',
    brandId: 'mcdonalds',
    amount: 15 as GiftAmount,
    senderId: 'sender-3',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 26),
    isRedeemed: false
  },
  {
    id: 'gift-mcdonalds-6',
    brandId: 'mcdonalds',
    amount: 25 as GiftAmount,
    senderId: 'sender-6',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 24),
    isRedeemed: false
  },
  
  // Burger King gifts (restaurants) - 5 transactions
  {
    id: 'gift-burgerking-1',
    brandId: 'burgerking',
    amount: 5 as GiftAmount,
    senderId: 'sender-3',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 28),
    isRedeemed: false
  },
  {
    id: 'gift-burgerking-2',
    brandId: 'burgerking',
    amount: 10 as GiftAmount,
    senderId: 'sender-3',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 27),
    isRedeemed: false
  },
  {
    id: 'gift-burgerking-3',
    brandId: 'burgerking',
    amount: 10 as GiftAmount,
    senderId: 'sender-5',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 25),
    isRedeemed: false
  },
  {
    id: 'gift-burgerking-4',
    brandId: 'burgerking',
    amount: 15 as GiftAmount,
    senderId: 'sender-6',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 23),
    isRedeemed: false
  },
  {
    id: 'gift-burgerking-5',
    brandId: 'burgerking',
    amount: 15 as GiftAmount,
    senderId: 'sender-1',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 21),
    isRedeemed: false
  },
  
  // Chick-fil-A gifts (restaurants) - 4 transactions
  {
    id: 'gift-chickfila-1',
    brandId: 'chickfila',
    amount: 5 as GiftAmount,
    senderId: 'sender-2',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 22),
    isRedeemed: false
  },
  {
    id: 'gift-chickfila-2',
    brandId: 'chickfila',
    amount: 10 as GiftAmount,
    senderId: 'sender-4',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 21),
    isRedeemed: false
  },
  {
    id: 'gift-chickfila-3',
    brandId: 'chickfila',
    amount: 15 as GiftAmount,
    senderId: 'sender-3',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 20),
    isRedeemed: false
  },
  {
    id: 'gift-chickfila-4',
    brandId: 'chickfila',
    amount: 25 as GiftAmount,
    senderId: 'sender-1',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 19),
    isRedeemed: false
  },
  
  // Taco Bell gifts (restaurants) - 4 transactions
  {
    id: 'gift-tacobell-1',
    brandId: 'tacobell',
    amount: 5 as GiftAmount,
    senderId: 'sender-5',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 18),
    isRedeemed: false
  },
  {
    id: 'gift-tacobell-2',
    brandId: 'tacobell',
    amount: 10 as GiftAmount,
    senderId: 'sender-2',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 17),
    isRedeemed: false
  },
  {
    id: 'gift-tacobell-3',
    brandId: 'tacobell',
    amount: 10 as GiftAmount,
    senderId: 'sender-4',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 16),
    isRedeemed: false
  },
  {
    id: 'gift-tacobell-4',
    brandId: 'tacobell',
    amount: 15 as GiftAmount,
    senderId: 'sender-3',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 15),
    isRedeemed: false
  },
  
  // CVS gifts (convenience) - 6 transactions
  {
    id: 'gift-cvs-1',
    brandId: 'cvs',
    amount: 5 as GiftAmount,
    senderId: 'sender-5',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 26),
    isRedeemed: false
  },
  {
    id: 'gift-cvs-2',
    brandId: 'cvs',
    amount: 5 as GiftAmount,
    senderId: 'sender-3',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 25),
    isRedeemed: false
  },
  {
    id: 'gift-cvs-3',
    brandId: 'cvs',
    amount: 10 as GiftAmount,
    senderId: 'sender-1',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 24),
    isRedeemed: false
  },
  {
    id: 'gift-cvs-4',
    brandId: 'cvs',
    amount: 10 as GiftAmount,
    senderId: 'sender-2',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 22),
    isRedeemed: false
  },
  {
    id: 'gift-cvs-5',
    brandId: 'cvs',
    amount: 15 as GiftAmount,
    senderId: 'sender-4',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 21),
    isRedeemed: false
  },
  {
    id: 'gift-cvs-6',
    brandId: 'cvs',
    amount: 25 as GiftAmount,
    senderId: 'sender-6',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 20),
    isRedeemed: false
  },
  
  // Walmart gifts (convenience) - 5 transactions
  {
    id: 'gift-walmart-1',
    brandId: 'walmart',
    amount: 5 as GiftAmount,
    senderId: 'sender-2',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 19),
    isRedeemed: false
  },
  {
    id: 'gift-walmart-2',
    brandId: 'walmart',
    amount: 10 as GiftAmount,
    senderId: 'sender-3',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 18),
    isRedeemed: false
  },
  {
    id: 'gift-walmart-3',
    brandId: 'walmart',
    amount: 10 as GiftAmount,
    senderId: 'sender-5',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 17),
    isRedeemed: false
  },
  {
    id: 'gift-walmart-4',
    brandId: 'walmart',
    amount: 15 as GiftAmount,
    senderId: 'sender-1',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 16),
    isRedeemed: false
  },
  {
    id: 'gift-walmart-5',
    brandId: 'walmart',
    amount: 25 as GiftAmount,
    senderId: 'sender-4',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 15),
    isRedeemed: false
  },
  
  // Walgreens gifts (convenience) - 4 transactions
  {
    id: 'gift-walgreens-1',
    brandId: 'walgreens',
    amount: 5 as GiftAmount,
    senderId: 'sender-3',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 14),
    isRedeemed: false
  },
  {
    id: 'gift-walgreens-2',
    brandId: 'walgreens',
    amount: 10 as GiftAmount,
    senderId: 'sender-1',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 13),
    isRedeemed: false
  },
  {
    id: 'gift-walgreens-3',
    brandId: 'walgreens',
    amount: 15 as GiftAmount,
    senderId: 'sender-5',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 12),
    isRedeemed: false
  },
  {
    id: 'gift-walgreens-4',
    brandId: 'walgreens',
    amount: 25 as GiftAmount,
    senderId: 'sender-2',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 11),
    isRedeemed: false
  },
  
  // Rite Aid gifts (convenience) - 4 transactions
  {
    id: 'gift-riteaid-1',
    brandId: 'riteaid',
    amount: 5 as GiftAmount,
    senderId: 'sender-4',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 10),
    isRedeemed: false
  },
  {
    id: 'gift-riteaid-2',
    brandId: 'riteaid',
    amount: 10 as GiftAmount,
    senderId: 'sender-2',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 9),
    isRedeemed: false
  },
  {
    id: 'gift-riteaid-3',
    brandId: 'riteaid',
    amount: 15 as GiftAmount,
    senderId: 'sender-3',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 8),
    isRedeemed: false
  },
  {
    id: 'gift-riteaid-4',
    brandId: 'riteaid',
    amount: 25 as GiftAmount,
    senderId: 'sender-5',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 7),
    isRedeemed: false
  },
  
  // Xbox gifts (entertainment) - 5 transactions
  {
    id: 'gift-xbox-1',
    brandId: 'xbox',
    amount: 5 as GiftAmount,
    senderId: 'sender-3',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 25),
    isRedeemed: false
  },
  {
    id: 'gift-xbox-2',
    brandId: 'xbox',
    amount: 10 as GiftAmount,
    senderId: 'sender-1',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 23),
    isRedeemed: false
  },
  {
    id: 'gift-xbox-3',
    brandId: 'xbox',
    amount: 10 as GiftAmount,
    senderId: 'sender-5',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 21),
    isRedeemed: false
  },
  {
    id: 'gift-xbox-4',
    brandId: 'xbox',
    amount: 15 as GiftAmount,
    senderId: 'sender-2',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 19),
    isRedeemed: false
  },
  {
    id: 'gift-xbox-5',
    brandId: 'xbox',
    amount: 25 as GiftAmount,
    senderId: 'sender-4',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 17),
    isRedeemed: false
  },
  
  // PlayStation gifts (entertainment) - 4 transactions
  {
    id: 'gift-playstation-1',
    brandId: 'playstation',
    amount: 5 as GiftAmount,
    senderId: 'sender-5',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 16),
    isRedeemed: false
  },
  {
    id: 'gift-playstation-2',
    brandId: 'playstation',
    amount: 10 as GiftAmount,
    senderId: 'sender-2',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 14),
    isRedeemed: false
  },
  {
    id: 'gift-playstation-3',
    brandId: 'playstation',
    amount: 15 as GiftAmount,
    senderId: 'sender-3',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 12),
    isRedeemed: false
  },
  {
    id: 'gift-playstation-4',
    brandId: 'playstation',
    amount: 25 as GiftAmount,
    senderId: 'sender-4',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 10),
    isRedeemed: false
  },
  
  // AMC gifts (entertainment) - 6 transactions
  {
    id: 'gift-amc-1',
    brandId: 'amc',
    amount: 5 as GiftAmount,
    senderId: 'sender-1',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 17),
    isRedeemed: false
  },
  {
    id: 'gift-amc-2',
    brandId: 'amc',
    amount: 5 as GiftAmount,
    senderId: 'sender-3',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 16),
    isRedeemed: false
  },
  {
    id: 'gift-amc-3',
    brandId: 'amc',
    amount: 10 as GiftAmount,
    senderId: 'sender-2',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 15),
    isRedeemed: false
  },
  {
    id: 'gift-amc-4',
    brandId: 'amc',
    amount: 10 as GiftAmount,
    senderId: 'sender-5',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 13),
    isRedeemed: false
  },
  {
    id: 'gift-amc-5',
    brandId: 'amc',
    amount: 15 as GiftAmount,
    senderId: 'sender-4',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 11),
    isRedeemed: false
  },
  {
    id: 'gift-amc-6',
    brandId: 'amc',
    amount: 25 as GiftAmount,
    senderId: 'sender-6',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 9),
    isRedeemed: false
  },
  
  // Showcase Cinemas gifts (entertainment) - 4 transactions
  {
    id: 'gift-showcase-1',
    brandId: 'showcase',
    amount: 5 as GiftAmount,
    senderId: 'sender-3',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 14),
    isRedeemed: false
  },
  {
    id: 'gift-showcase-2',
    brandId: 'showcase',
    amount: 10 as GiftAmount,
    senderId: 'sender-2',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 12),
    isRedeemed: false
  },
  {
    id: 'gift-showcase-3',
    brandId: 'showcase',
    amount: 15 as GiftAmount,
    senderId: 'sender-5',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 10),
    isRedeemed: false
  },
  {
    id: 'gift-showcase-4',
    brandId: 'showcase',
    amount: 25 as GiftAmount,
    senderId: 'sender-1',
    recipientId: 'current-user',
    createdAt: new Date(2025, 2, 8),
    isRedeemed: false
  }
];

const MOCK_BRANDS: Brand[] = [
  // Restaurants
  { id: 'mcdonalds', name: 'McDonald\'s', logo: '/placeholder.svg', silo: 'restaurants' },
  { id: 'burgerking', name: 'Burger King', logo: '/placeholder.svg', silo: 'restaurants' },
  { id: 'chickfila', name: 'Chick-fil-A', logo: '/placeholder.svg', silo: 'restaurants' },
  { id: 'tacobell', name: 'Taco Bell', logo: '/placeholder.svg', silo: 'restaurants' },
  
  // Beverages
  { id: 'starbucks', name: 'Starbucks', logo: '/placeholder.svg', silo: 'beverages' },
  { id: 'dunkin', name: 'Dunkin\' Donuts', logo: '/placeholder.svg', silo: 'beverages' },
  { id: 'krispy', name: 'Krispy Kreme', logo: '/placeholder.svg', silo: 'beverages' },
  { id: 'timhortons', name: 'Tim Horton\'s', logo: '/placeholder.svg', silo: 'beverages' },
  
  // Convenience
  { id: 'walmart', name: 'Walmart', logo: '/placeholder.svg', silo: 'convenience' },
  { id: 'cvs', name: 'CVS', logo: '/placeholder.svg', silo: 'convenience' },
  { id: 'riteaid', name: 'Rite Aid', logo: '/placeholder.svg', silo: 'convenience' },
  { id: 'walgreens', name: 'Walgreens', logo: '/placeholder.svg', silo: 'convenience' },
  
  // Entertainment
  { id: 'amc', name: 'AMC Theatres', logo: '/placeholder.svg', silo: 'entertainment' },
  { id: 'showcase', name: 'Showcase Cinemas', logo: '/placeholder.svg', silo: 'entertainment' },
  { id: 'xbox', name: 'Xbox', logo: '/placeholder.svg', silo: 'entertainment' },
  { id: 'playstation', name: 'PlayStation', logo: '/placeholder.svg', silo: 'entertainment' },
];

const MarketPage = () => {
  const navigate = useNavigate();
  
  const handleBack = () => {
    navigate('/');
  };
  
  const totalBalance = MOCK_GIFTS.reduce((sum, gift) => sum + gift.amount, 0);
  
  const giftsBySilo: Record<string, number> = {
    restaurants: 0,
    beverages: 0,
    convenience: 0, 
    entertainment: 0
  };
  
  MOCK_GIFTS.forEach(gift => {
    const brand = MOCK_BRANDS.find(b => b.id === gift.brandId);
    if (brand) {
      giftsBySilo[brand.silo] += gift.amount;
    }
  });

  const uniqueSenders = [...new Set(MOCK_GIFTS.map(gift => gift.senderId))];
  const senderSummary = uniqueSenders.map(senderId => {
    const senderGifts = MOCK_GIFTS.filter(gift => gift.senderId === senderId);
    const totalAmount = senderGifts.reduce((sum, gift) => sum + gift.amount, 0);
    return {
      senderId,
      giftCount: senderGifts.length,
      totalAmount,
      lastGift: senderGifts.sort((a, b) => 
        b.createdAt.getTime() - a.createdAt.getTime()
      )[0]
    };
  });

  const uniqueBrands = [...new Set(MOCK_GIFTS.map(gift => gift.brandId))];
  const brandSummary = uniqueBrands.map(brandId => {
    const brandGifts = MOCK_GIFTS.filter(gift => gift.brandId === brandId);
    const totalAmount = brandGifts.reduce((sum, gift) => sum + gift.amount, 0);
    const brand = MOCK_BRANDS.find(b => b.id === brandId);
    return {
      brandId,
      brandName: brand?.name || 'Unknown',
      giftCount: brandGifts.length,
      totalAmount,
      silo: brand?.silo || 'unknown'
    };
  });
  
  return (
    <Layout>
      <div className="pb-8">
        <div className="flex justify-between items-center mb-6">
          <div className="flex items-center gap-2">
            <h1 className="text-2xl font-bold">GivGo Market</h1>
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Button variant="ghost" size="icon" className="rounded-full">
                    <Info className="h-4 w-4 text-givgo-purple" />
                  </Button>
                </TooltipTrigger>
                <TooltipContent className="max-w-md p-4">
                  <p className="font-medium text-givgo-purple mb-2">Welcome to the GivGo Market!</p>
                  <p className="mb-2">The GivGo Market gives you complete control over your micro-gifting experience:</p>
                  <ul className="list-disc pl-5 space-y-1">
                    <li><span className="font-medium">Use:</span> Redeem your GivGo Bucks at the intended brand</li>
                    <li><span className="font-medium">Exchange:</span> Swap for another brand's GivGo Bucks</li>
                    <li><span className="font-medium">Re-Gift:</span> Share with friends in your network</li>
                    <li><span className="font-medium">Convert:</span> Turn GivGo Bucks into real money via Venmo</li>
                  </ul>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6">
          <Card className="bg-green-50">
            <CardContent className="flex flex-col items-center justify-center py-6">
              <div className="text-3xl font-bold text-green-600">${giftsBySilo.restaurants}</div>
              <div className="text-sm text-muted-foreground">Restaurant Bucks</div>
            </CardContent>
          </Card>
          
          <Card className="bg-blue-50">
            <CardContent className="flex flex-col items-center justify-center py-6">
              <div className="text-3xl font-bold text-blue-600">${giftsBySilo.beverages}</div>
              <div className="text-sm text-muted-foreground">Beverage Bucks</div>
            </CardContent>
          </Card>
          
          <Card className="bg-amber-50">
            <CardContent className="flex flex-col items-center justify-center py-6">
              <div className="text-3xl font-bold text-amber-600">${giftsBySilo.convenience}</div>
              <div className="text-sm text-muted-foreground">Convenience Bucks</div>
            </CardContent>
          </Card>
          
          <Card className="bg-purple-50">
            <CardContent className="flex flex-col items-center justify-center py-6">
              <div className="text-3xl font-bold text-purple-600">${giftsBySilo.entertainment}</div>
              <div className="text-sm text-muted-foreground">Entertainment Bucks</div>
            </CardContent>
          </Card>
          
          <Card className="bg-givgo-light">
            <CardContent className="flex flex-col items-center justify-center py-6">
              <div className="text-3xl font-bold text-givgo-purple">${totalBalance}</div>
              <div className="text-sm text-muted-foreground">Total GivGo Bucks</div>
            </CardContent>
          </Card>
        </div>
        
        <div className="bg-white p-4 rounded-lg border mb-6 flex items-center justify-between">
          <div className="text-muted-foreground flex items-center">
            You have gifts from 
            <HoverCard>
              <HoverCardTrigger className="mx-1">
                <span className="font-medium text-givgo-purple cursor-help underline decoration-dotted">
                  {MOCK_GIFTS.length} friends
                </span>
              </HoverCardTrigger>
              <HoverCardContent className="w-80">
                <h4 className="font-semibold mb-2">Friend Summary</h4>
                <div className="space-y-2 max-h-60 overflow-y-auto">
                  {senderSummary.map((sender) => (
                    <div key={sender.senderId} className="p-2 rounded-md bg-gray-50">
                      <div className="flex justify-between">
                        <span className="font-medium">Friend {sender.senderId.replace('sender-', '')}</span>
                        <span className="text-givgo-purple">${sender.totalAmount}</span>
                      </div>
                      <div className="text-xs text-muted-foreground">
                        {sender.giftCount} gift{sender.giftCount !== 1 ? 's' : ''} • Last sent on {sender.lastGift.createdAt.toLocaleDateString()}
                      </div>
                    </div>
                  ))}
                </div>
              </HoverCardContent>
            </HoverCard>
            across 
            <HoverCard>
              <HoverCardTrigger className="mx-1">
                <span className="font-medium text-givgo-purple cursor-help underline decoration-dotted">
                  {new Set(MOCK_GIFTS.map(g => g.brandId)).size} brands
                </span>
              </HoverCardTrigger>
              <HoverCardContent className="w-80">
                <h4 className="font-semibold mb-2">Brand Summary</h4>
                <div className="space-y-2 max-h-60 overflow-y-auto">
                  {brandSummary.map((brand) => (
                    <div key={brand.brandId} className="p-2 rounded-md bg-gray-50">
                      <div className="flex justify-between">
                        <span className="font-medium">{brand.brandName}</span>
                        <span className="text-givgo-purple">${brand.totalAmount}</span>
                      </div>
                      <div className="text-xs text-muted-foreground">
                        {brand.giftCount} gift{brand.giftCount !== 1 ? 's' : ''} • {brand.silo} category
                      </div>
                    </div>
                  ))}
                </div>
              </HoverCardContent>
            </HoverCard>
          </div>
          <Link to="/activity">
            <Button variant="outline" size="sm" className="flex items-center gap-2">
              <Activity className="h-4 w-4" /> View Activity
            </Button>
          </Link>
        </div>
        
        <MicroGiftInventory 
          gifts={MOCK_GIFTS} 
          brands={MOCK_BRANDS} 
          onBack={handleBack}
        />
      </div>
    </Layout>
  );
};

export default MarketPage;
